// extracted by mini-css-extract-plugin
export default {"toggle_switch":"style_toggle_switch__j4qhn","slider":"style_slider__2gEcH"};